import { Col } from 'reactstrap'
import { H3 } from '../../../../AbstractElements'
import { SubtractiveBorder } from '../../../../utils/Constant'
import { subtractiveData } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'

const SubtractiveBorders = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H3 className="mb-3">{SubtractiveBorder}</H3>
        <div className="helper-common-box">
          <div className="helper-box bg-light border border-0"> </div>.border-0
        </div>
        {subtractiveData.map((item ,index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box bg-light border border-${item}`}> </div>.border-{item}
          </div>
        ))}
      </div>
    </Col>
  )
}

export default SubtractiveBorders